import { InvoicePixProps } from "../../pages/invoices/pix/pix";
import { ActionProps, UserProps } from "./props";

export function setUser(user: UserProps): ActionProps {
  return {
    type: "SET_USER",
    user,
  };
}

export function setBenoToken(benoToken: string): ActionProps {
  return {
    type: "SET_USER_BENOTOKEN",
    benoToken,
  };
}

export function setInvoicePix(invoicePix?: InvoicePixProps): ActionProps {
  return {
    type: "SET_INVOICE_PIX",
    invoicePix,
  };
}
